import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  remember(event) {
    const control = event.target.closest("[data-trend-filter], [data-comparison-control]")
    if (!control) return
    this.scrollPosition = window.scrollY
    this.timelinePosition = this.element.querySelector(".chronology__scroll, .trend-story__scroll")?.scrollLeft
    this.topicTimelinePosition = this.element.querySelector(".topic-history__scroll")?.scrollLeft
    this.discussionOpen = this.element.querySelector(".trend-comparison__discussion")?.open
    this.focusKey = event.target.closest("[data-comparison-focus]")?.dataset.comparisonFocus ||
      document.activeElement?.dataset.comparisonFocus
  }

  loaded(event) {
    if (event.target !== this.element || this.scrollPosition == null) return
    const position = this.scrollPosition
    const timelinePosition = this.timelinePosition
    const topicTimelinePosition = this.topicTimelinePosition
    const focusKey = this.focusKey
    const discussion = this.element.querySelector(".trend-comparison__discussion")
    if (discussion && this.discussionOpen) discussion.open = true
    this.scrollPosition = null
    this.focusKey = null
    window.requestAnimationFrame(() => {
      const focusTarget = (focusKey && this.element.querySelector(`[data-comparison-focus="${CSS.escape(focusKey)}"]`)) ||
        this.element.querySelector(".trend-filters [aria-current='page']")
      focusTarget?.focus({ preventScroll: true })
      window.scrollTo({ top: position, behavior: "instant" })
      const timeline = this.element.querySelector(".chronology__scroll, .trend-story__scroll")
      if (timeline && timelinePosition != null) timeline.scrollLeft = timelinePosition
      const topicTimeline = this.element.querySelector(".topic-history__scroll")
      if (topicTimeline && topicTimelinePosition != null && !focusKey?.startsWith("dot-")) {
        topicTimeline.scrollLeft = topicTimelinePosition
      }
    })
  }
}
